import { type ReactNode } from "react";
import { cx } from "shared/utils/classnames";
import { useInboxEmbed } from "../context/useInboxEmbed";
import { useInComposerFooter } from "../context/useComposerNarrow";

export const RoutingFieldsRow = ({
  from,
  to
}: {
  from: ReactNode;
  to: ReactNode;
}) => {
  const isCompact = Boolean(useInboxEmbed()?.compact);
  const inFooter = useInComposerFooter() && !isCompact;
  const fieldClass = cx(
    inFooter && "shrink-0",
    isCompact && "min-w-0 flex-1",
    !inFooter && !isCompact && "min-w-0 shrink"
  );
  const groupClass = cx("flex items-center gap-2 text-sm", fieldClass);

  return (
    <div
      className={cx(
        "flex flex-row flex-nowrap items-center gap-4",
        inFooter ? "shrink-0" : "min-w-0"
      )}
    >
      <div className={groupClass}>
        <span className="text-content-400 font-medium whitespace-nowrap">
          From:
        </span>
        <div className={fieldClass}>{from}</div>
      </div>

      <div className={groupClass}>
        <span className="text-content-400 font-medium whitespace-nowrap">
          To:
        </span>
        <div className={fieldClass}>{to}</div>
      </div>
    </div>
  );
};
